import { sendGridSyncEndpoint } from 'root/src/server/modules/mails/endpoints/sendGridSync.endpoint';
export const mailsEndpoints = Object.assign({}, sendGridSyncEndpoint);
